import { ENV_VARS } from '@/env';
import { Col, Modal, Row } from 'antd';
import i18n from 'i18next';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import Button from '../Buttons/Button';
import IconButton from '../Buttons/IconButton';
import SvgConverter from '../Common/SvgConverter';

const ConfirmationModal = ({
  open = false,
  cancelButton = false,
  title = 'Title',
  okText = i18n.t('translation:default.options.yes'),
  cancelText = i18n.t('translation:default.options.no'),
  description = i18n.t('translation:default.fields.description'),
  onClose = () => {},
  onOk = () => {},
  onCancel = () => {},
  okButtonVariant = 'success',
  okLoading = false,
  closeButtonId = 'warning-close',
  yesButtonId = 'warning-yes',
  noButtonId = 'warning-no',
}) => {
  const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

  return (
    <Modal className="common-confirmation-modal" closable={false} centered footer={false} open={open}>
      <Row className={`header-section ${isHBUser ? 'hb-bg-color' : ''}`} justify="space-between" align="middle">
        <Col>
          {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
          <label className="title">{title}</label>
        </Col>
        <Col className="lh-0">
          <IconButton onClick={onClose} disabled={okLoading} id={closeButtonId}>
            <SvgConverter Icon={CloseIcon} color="white" />
          </IconButton>
        </Col>
      </Row>
      <div className="content-section">
        <div className="description">{description}</div>
        <Row className="footer-section" justify="end">
          <Col>
            <Row gutter={20}>
              <Col>
                <Button
                  variant={okButtonVariant}
                  onClick={onOk}
                  loading={okLoading}
                  id={yesButtonId}
                  className={isHBUser ? 'hb-button' : ''}
                >
                  {okText}
                </Button>
              </Col>
              {!cancelButton && (
                <Col>
                  <Button
                    disabled={okLoading}
                    variant="danger"
                    type="default"
                    onClick={onCancel}
                    id={noButtonId}
                    className={isHBUser ? 'hb-button' : ''}
                  >
                    {cancelText}
                  </Button>
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
